import { interpolate } from "../utils";
export default function login(ulmUrl) {
    if (ulmUrl) {
        var currentLocation = encodeURIComponent(window.location.href);
        window.location.href = interpolate(ulmUrl, { location: currentLocation });
    }
}
